export const googletag = window.googletag || { cmd: [] }

export const osano = window.Osano
